import type { ChartConfig } from "./charts";
import type { ChartLike, ChartSettings, PartialChartItem } from "./ChartItem";
import { defaultChartSettings, defaultDataToggles, defaultData, defaultItemConfigs } from "./ChartItem";
import { cloneDeep } from "lodash-es";

export function getAxisConfig(
  chartConfig: ChartConfig,
  x?: string,
  y?: string
) {
  if (!chartConfig) return undefined;
  return chartConfig.axisOptions.find((o) => {
    if (x && y) return o.x == x && o.y == y;
    if (x) return o.x == x;
    if (y) return o.y == y;
    return false;
  });
}

export function fillChartWithDefaults<T extends PartialChartItem>(options: T): T & Omit<ChartLike, "title" | "titleIsCustom"> {
  type Result = T & Omit<ChartLike, "title" | "titleIsCustom">;

  const filledDataToggles: ChartLike["dataToggles"] = {
    all: {
      ...cloneDeep(defaultDataToggles.all),
      ...options.dataToggles?.all
    }
  };

  const filledItemConfigs: ChartLike["itemConfigs"] = {
    ...cloneDeep(defaultItemConfigs),
    ...options.itemConfigs
  };

  const filledData: ChartLike["data"] = {
    ...cloneDeep(defaultData),
    ...options.data
  };

  const filledSettings: ChartSettings = {
    ...cloneDeep(defaultChartSettings),
    ...options.chartSettings
  };

  const filled: Result = {
    ...options,

    chartType: options.chartType ?? null,
    dataToggles: filledDataToggles,
    data: filledData,
    itemConfigs: filledItemConfigs,
    chartSettings: filledSettings
  };

  return filled;
}
